// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2 3.5H7.5M10 3.5H14M10 2V5',
  'M2 8H5M5 6.5V9.5M7.5 8H14',
  'M2 12.5H9M11.5 12.5H14M11.5 11V14',
];
